import React from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import './style.css';
import { DeviceVendor } from '../../types/device';
import withStyles from '@mui/styles/withStyles';

const StyledTabs = withStyles({
    root: {
        color: 'black',
        height: 28,
        '& .contentBox.MuiTabs-root':{
            left: '25px',
        },
        '& .MuiTab-textColorPrimary.Mui-selected': {
            color: '#1976d2',
        },
        '& .MuiTab-textColorPrimary': {
            color: 'rgba(0, 0, 0, 0.54)',
        },
        '& .MuiTabs-indicator': {
            backgroundColor: '#1976d2',
        },
    },
})(Tabs);


export const TabBarMenu: React.FC<{ value: any; deviceVendor: string; setValue: (arg0: any) => void }> = (props) => {
   // const classes = useStyles();
    const [value, setValue] = React.useState(props.value);
    return (
        <div data-testid="tabBar">
            <StyledTabs
                value={value}
                onChange={(event: any, newValue: any): void => {
                    setValue(newValue);
                    props.setValue(newValue);
                    const element = window.document.getElementById('root');
                    if (element !== null) {
                        element.scrollTo({
                            top: 0,
                            behavior: 'smooth',
                        });
                    }
                }}
                indicatorColor="primary"
                textColor="primary"
                style={{ marginLeft: '0px' }}
            >
                <Tab label="DEVICE DETAIL" data-testid="tab-deviceDetails" />
                <Tab label="TRENDS" data-testid="tab-deviceTrends" />
                <Tab label="PROPERTIES" data-testid="tab-deviceProperties" />
                {props.deviceVendor.toLowerCase() === DeviceVendor.Insulgard && (
                    <Tab label="CONDITION INDEX" data-testid="tab-conditionIndex" />
                )}
                {props.deviceVendor.toLowerCase() === DeviceVendor.Insulgard && (
                    <Tab label="SENSORS TRENDS" data-testid="tab-sensorTrends" />
                )}
                {props.deviceVendor.toLowerCase() === DeviceVendor.Insulgard && (
                    <Tab label="PHASE-RESOLVED CHARTS" data-testid="tab-phaseResolved" />
                )}

                {props.deviceVendor.toLowerCase() === DeviceVendor.Insulgard && (
                    <Tab label="REPORTS" data-testid="tab-reports" />
                )}
               
            </StyledTabs>
        </div>
    );
};